import React from 'react';
import 'bulma/css/bulma.min.css';
import { Card, useAuth } from 'qwanyx';

export const Ide = ({ children }) => {
  const { currentUser } = useAuth();
  return (
    <Card
      _id={currentUser.id}
      di="645b5e00c7b61df466430901"
      pa="680cf662722180eafca5e443"
    />
  );
};

export default Ide;